import React from 'react';
import {PageContainer, PageContent, PageHeader} from '../../components/Page';
import Helmet from 'react-helmet';
import { withRouteData } from 'react-static';

export default withRouteData(({content}) => <React.Fragment>
  <Helmet title={content ? content.title : ''} />
  <PageContainer className={content && !content.headerImage ? 'with-a-bit-of-spacing' : ''}>
    { content && content.headerImage && <PageHeader image={content ? content.headerImage : ''} /> }
    <PageContent html={content ? content.body : ''} />
  </PageContainer>
</React.Fragment>);